export const OCR_GUIDE_ROW_HEIGHT = 27;
export const RECEIPT_INPUT_HEIGHT = 25;

export const baseOutlinedInputStyles = {
  '& .MuiOutlinedInput-root': {
    paddingTop: 0,
    paddingBottom: 0,
    height: '17px',
    minHeight: '17px',
    maxHeight: '17px',
    backgroundColor: '#ffffff',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputBase-input': {
    height: '17px',
    minHeight: '17px',
    maxHeight: '17px',
    lineHeight: '17px',
    backgroundColor: '#ffffff',
  },
  '& .MuiOutlinedInput-input': {
    p: '2px 4px !important',
  },
};

export const receiptOutlinedInputStyles = {
  '& .MuiOutlinedInput-root': {
    paddingTop: 0,
    paddingBottom: 0,
    height: `${RECEIPT_INPUT_HEIGHT}px`,
    minHeight: `${RECEIPT_INPUT_HEIGHT}px`,
    maxHeight: `${RECEIPT_INPUT_HEIGHT}px`,
    backgroundColor: 'transparent',
    borderRadius: 0,
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputBase-input': {
    height: `${RECEIPT_INPUT_HEIGHT}px`,
    minHeight: `${RECEIPT_INPUT_HEIGHT}px`,
    maxHeight: `${RECEIPT_INPUT_HEIGHT}px`,
    lineHeight: `${RECEIPT_INPUT_HEIGHT}px`,
    backgroundColor: 'transparent',
  },
  '& .MuiOutlinedInput-input': {
    p: '0 4px !important',
  },
};

export const mergeOutlinedInputStyles = (styles: Record<string, any> = {}) => ({
  ...styles,
  '& .MuiOutlinedInput-root': {
    ...baseOutlinedInputStyles['& .MuiOutlinedInput-root'],
    ...(styles['& .MuiOutlinedInput-root'] || {}),
  },
});

export const buildOutlinedErrorBorderStyles = (hasError: boolean) => {
  if (!hasError) {
    return {};
  }

  return {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '1px solid',
        borderColor: 'error.main',
      },
      '&:hover fieldset': {
        border: '1px solid',
        borderColor: 'error.main',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid',
        borderColor: 'error.main',
      },
    },
  };
};
